/** * 系统错误日志 */
<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<!-- 搜索筛选 -->
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="模块：">
					<el-input clearable v-model="formInline.apiModule" size="small" placeholder="请输入模块" @keyup.enter.native="search"></el-input>
				</el-form-item>
				<el-form-item label="关键字：">
					<el-input clearable v-model="formInline.keyword" size="small" placeholder="标题/异常类型/方法" @keyup.enter.native="search"></el-input>
				</el-form-item>
				<el-form-item label="起止日期：">
					<el-date-picker
						v-model="timeData"
						size="small"
						value-format="yyyy-MM-dd"
						type="daterange"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="timeChange"
						@input="$forceUpdate()"
					></el-date-picker>
				</el-form-item>
				<el-form-item class="btnList">
					<el-button size="small" type="primary" icon="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right; margin-right: 0">
					<el-button size="small" type="danger" icon="el-icon-delete" :disabled="selectionList.length === 0" @click="handleBatchDelete">批量删除</el-button>
				</el-form-item>
			</el-form>
			<!--列表-->
			<STable ref="dataTable" :columns="columnsData" :data="listData" :loading="loading" :row-key="'keyId'"
				@get-data="getListData" @changeSelection="handleSelectionChange" @handle-command="handleCommand"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 详情 -->
		<detail ref="detail"></detail>
	</div>
</template>

<script>
import { GetSystemErrorLogList, DeleteSystemErrorLog } from "@/api/systemErrorLogApi.js";
import detail from "./detail.vue";

export default {
	components: { detail },
	data() {
		return {
			activeTab: "1",
			tabData: [{ key: "1", value: "错误日志" }],
			pageShow: true,
			loading: false,
			listData: [],
			selectionList: [],
			pageparm: { pageIndex: 1, pageSize: 15, total: 0 },
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				apiModule: "",
				keyword: "",
				startTime: null,
				endTime: null,
			},
			timeData: [],
			columnsData: [],
			listColumns: [
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ prop: "createTime", label: "时间", width: "170", align: "center" },
				{ prop: "apiModule", label: "模块", width: "220", align: "center" },
				{ prop: "title", label: "主要信息", minWidth: "260", align: "left" },
				{ prop: "exceptionType", label: "异常类型", width: "260", align: "center" },
				{ prop: "requestMethod", label: "调用方法", width: "220", align: "center" },
				{ prop: "methodLocation", label: "方法位置", width: "320", align: "center" },
				{ prop: "operatorName", label: "操作人", width: "120", align: "center" },
				{
					operation: true, isKeep: true, label: "操作", width: "160", align: "center", fixed: "right",
					btnGroup: [
						{ icon: "el-icon-view", name: "详情", type: "1", btnType: "primary" },
						{ icon: "el-icon-delete", name: "删除", type: "2", btnType: "danger" },
					],
				},
			],
		};
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	methods: {
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		getListData() {
			this.loading = true;
			GetSystemErrorLogList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange() {
			this.search();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		timeChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		clearAll() {
			this.formInline = this.$options.data.call(this).formInline;
			this.timeData = [];
			this.search();
		},
		handleSelectionChange(val) {
			this.selectionList = val || [];
		},
		handleCommand(command) {
			if (command.command == "1") {
				this.$refs.detail.showDetail(command.rowData.keyId);
			} else if (command.command == "2") {
				this.handleDelete([command.rowData.keyId]);
			}
		},
		handleBatchDelete() {
			this.handleDelete(this.selectionList.map((x) => x.keyId));
		},
		handleDelete(keyIds) {
			this.$confirm("确定要删除选中的错误日志吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				DeleteSystemErrorLog({ keyIds: keyIds }).then((res) => {
					if (res.code === 1) {
						this.$message.success("删除成功！");
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				});
			}).catch(() => {});
		},
	},
};
</script>

<style scoped></style>
